var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.707 39.707l-1.414-1.414L51.586 32H67a1 1 0 001-1V11a1 1 0 00-1-1H35a1 1 0 00-1 1v9h-2v-9c0-1.654 1.346-3 3-3h32c1.654 0 3 1.346 3 3v20c0 1.654-1.346 3-3 3H52.414l-5.707 5.707",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M46 22h2v-2h-2zM50 22h2v-2h-2zM54 22h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 72h-2v-7c0-8.01 4.445-9.7 9.152-11.488 1.743-.662 3.544-1.347 5.352-2.38l.992 1.736c-1.943 1.111-3.903 1.856-5.633 2.513C15.128 57.181 12 58.369 12 65v7M56 72h-2v-7c0-6.631-3.128-7.819-7.863-9.619-1.73-.657-3.69-1.402-5.633-2.513l.992-1.736c1.808 1.033 3.609 1.718 5.352 2.38C51.555 55.3 56 56.99 56 65v7",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 52.882l3.803 1.901 2.91-2.91-1.187-1.78-5.526.921-5.526-.921-1.187 1.78 2.91 2.91L33 52.882zm4.197 4.335L33 55.118l-4.197 2.099-5.09-5.09 2.813-4.22L33 48.986l6.474-1.079 2.813 4.22-5.09 5.09z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M37 49h2v-4h-2zM27 49h2v-4h-2zM32 64h2v-2h-2zM32 60h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 47c-.132 0-3.261-.013-5.447-1.105l-.108-.063c-.137-.092-3.383-2.333-4.435-9.69L23 36v-4h2v3.929c.861 5.917 3.2 7.96 3.519 8.212 1.762.844 4.455.859 4.482.859.025 0 2.717-.015 4.478-.858.313-.25 2.661-2.305 3.521-8.213V32h2l-.01 4.142c-1.052 7.357-4.298 9.598-4.435 9.69l-.108.063C36.261 46.987 33.132 47 33 47M43 32h-2c0-5.532-2.468-8-8-8s-8 2.468-8 8h-2c0-6.636 3.364-10 10-10s10 3.364 10 10",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M38.046 35.096l-10-4-3.599 1.799-.894-1.79 4.401-2.201 10 4 3.599-1.799.894 1.79-4.401 2.201M18 72h2v-6h-2zM46 72h2v-6h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationFeedback;